const LayoutWrapper = ({ children, className = "" , parentClassName="p-4"}: {
  children?: any,
  className?: string,
  parentClassName?: string
}) => {
  return (
    <div className={` w-full flex  justify-center ${parentClassName}`}>
      <div
        className={`
          w-full max-w-344
          flex flex-col
          ${className}
        `}
      >
        {children}
      </div>
    </div>
  );
};

export default LayoutWrapper;
